export default function KycPendingViaRain() {
  return (
    <div className="flex flex-col gap-[10px]" style={{ gap: "10px" }}>
      <div
        className="rounded-[4px] border border-[#292930] bg-black flex flex-col items-center justify-center gap-[15px] h-[372px]"
        style={{ height: "372px", gap: "15px" }}
      >
        <PendingSvg />
        <p className="text-[#E6E8ED] text-center font-['Neue Montreal'] text-[23.391px] font-medium leading-[120%]">
          Processing your
          <br />
          KYC Verificationn
        </p>
      </div>
      <p className="text-[#E6E8ED] text-center font-['Neue Montreal'] text-[16px] font-medium leading-[120%]">
        Your KYC verification is pending and may take up to 2 days. Please check
        back later for updates.
      </p>
    </div>
  );
}

const PendingSvg = () => {
  return (
    <svg
      width="88"
      height="89"
      viewBox="0 0 88 89"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.49609 3.19922H43.7531L54.4651 12.993V72.98H5.49609V3.19922Z"
        fill="#FFAD0D"
      />
      <path
        d="M41.2347 8.17186H7.9063V67.5467H52.3441V19.3047H41.2347V8.17186ZM7.9063 0.75H44.9378L59.7504 15.5937V67.5467C59.7504 69.5151 58.9701 71.4029 57.5812 72.7948C56.1922 74.1867 54.3084 74.9686 52.3441 74.9686H7.9063C5.94203 74.9686 4.05821 74.1867 2.66926 72.7948C1.2803 71.4029 0.5 69.5151 0.5 67.5467V8.17186C0.5 6.20346 1.2803 4.31568 2.66926 2.92381C4.05821 1.53194 5.94203 0.75 7.9063 0.75ZM15.3126 34.1484H44.9378V41.5702H15.3126V34.1484ZM15.3126 48.9921H44.9378V56.414H15.3126V48.9921Z"
        fill="#0D0D10"
      />
      <path
        d="M54.4465 61.1122C44.3921 61.1122 24.3926 66.6428 24.3926 77.5397V85.7535H84.5005V77.5397C84.5005 66.6428 64.5009 61.1122 54.4465 61.1122ZM61.0584 54.6894C65.2113 52.3348 68.1074 47.8994 68.1074 42.7521C68.1074 35.1954 61.9873 29.0625 54.4465 29.0625C46.9057 29.0625 40.7856 35.1954 40.7856 42.7521C40.7856 47.8994 43.6817 52.3348 47.8347 54.6894C49.8018 55.7846 52.0422 56.4417 54.4465 56.4417C56.8508 56.4417 59.0912 55.7846 61.0584 54.6894Z"
        fill="white"
        stroke="#0D0D10"
        strokeWidth="5.25554"
      />
    </svg>
  );
};
